<np-add-beneficiary-step></np-add-beneficiary-step>

<div class="col-md-10 offset-md-1">
  <div class="receipient-header">
    <strong *ngIf="action !== addRecipientFrom.Bank">Add new beneficiary |</strong>
    <strong *ngIf="action === addRecipientFrom.Bank">Bank Account Details |</strong> 2FA Security
  </div>
</div>

<np-pin-twillio-authy [buttonName]="btnName" [email]="registerService.email" (onetouchApproved)="onetouchApproved()"
  (submitted)="onSubmitted($event)" (sendCode)="sendPassCode($event)" [pinCodeError]="pinCodeError"
  [ticketType]="ticketType" (exceedInvalidCode)="exceedInvalidCode()" (validPin)="changeStatus($event)"
  [sendOnetouchSuccess]="sendOnetouchSuccess"></np-pin-twillio-authy>